import { render, staticRenderFns } from "./StakeSelection.vue?vue&type=template&id=11d64c74&scoped=true"
import script from "./StakeSelection.vue?vue&type=script&lang=js"
export * from "./StakeSelection.vue?vue&type=script&lang=js"
import style0 from "./StakeSelection.vue?vue&type=style&index=0&id=11d64c74&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d64c74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11d64c74')) {
      api.createRecord('11d64c74', component.options)
    } else {
      api.reload('11d64c74', component.options)
    }
    module.hot.accept("./StakeSelection.vue?vue&type=template&id=11d64c74&scoped=true", function () {
      api.rerender('11d64c74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/challenge-friends/components/StakeSelection.vue"
export default component.exports